export default {
    //landingPage
    landingPageTabTitle: "דף נחיתה | powerdoc",

    //landingPageForm
    landingPageFormChannelSelect: "לאן לשלוח לך את המסמך?",
    landingPageFormAllowChannelTag1: "SMS",
    landingPageFormAllowChannelTag2: "מייל",
    landingPageFormAutoEmailLabel: "מייל לקבלת עותק המסמך החתום",
    landingPageFormBroswer: "בלחיצה על הכפתור המסמך יפתח בדפדפן",
    landingPageFormTarget1: "במקביל ל SMS",
    landingPageFormTarget2: "במקביל למייל",
    landingPageFormChannelEmailLabel: "מייל",
    landingPageFormChannelMobileLabel: "נייד",
    landingPageFormPoweredBy: "Powered By ",

    fieldRequired:"שדה חובה",
    ruleEmailAdd: "יש להקליד כתובת מייל חוקית",
    ruleRequired:"חובה למלא שדה זה",
    rulePhone: "נא להזין מספר נייד חוקי",//*signup
    ruleLessThan:"חייבים להיות פחות מ",
    character:"תווים",
    ruleAtLeast:"חייבים להיות לפחות",

    //appStatus
    appStatusImgSentSuccess: "/static/img/appStatus_Success.png",
    appStatusTitleSentSuccess: "קישור למסמך נוצר בהצלחה",
    appStatusSubtitleSentSuccessPhone: "ונשלח אליך במסרון",
    appStatusSubtitleSentSuccessEmail: "ונשלח אליך במייל",
    appStatusSubtitleSentSuccessBrowser: "ומיד יפתח בדפדפן",
    appStatusThridTitleSentSuccessCurrentBroswer: "הקישור יפתח בחלון זה",
    appStatusThridTitleSentSuccessNewBroswer: "הקישור יפתח בחלון חדש",
    appStatusImgGlobalError: "/static/img/appStatus_NotValid.png",
    appStatusTitleGlobalError: "הקישור לדף נחיתה אינו זמין",
    appStatusImgSentFailed: "/static/img/appStatus_Failure.png",
    appStatusTitleSentFailed: "שגיאה",
    appStatusSubtitleSentFailed: "שגיאה בתהליך יצירת הקישור למסמך",
    appStatusThirdTitleSentFailed: "ניתן לחזור אחורה",
    appStatusBackBtnSentFailed: "חזרה למילוי הטופס",
    appStatusContactDetails: "ניתן לפנות ל ",

    //error
    err4093010: "ייתכן כי כבר נשלח אליך קישור למסמך",
    err4093011: "זמנית לא ניתן לקבל קישור למסמך, יש לנסות שנית עוד מספר דקות",
    err4093007: "תוקף דף הנחיתה הסתיים, יש לחזור חזרה למילוי הטופס ולנסות שנית",
    err4093009: "דף נחיתה אינו זמין",
    err4097002: "דף נחיתה אינו זמין",

}